import { render, staticRenderFns } from "./CardListSuket.vue?vue&type=template&id=2b365f16&scoped=true&"
import script from "./CardListSuket.vue?vue&type=script&lang=ts&"
export * from "./CardListSuket.vue?vue&type=script&lang=ts&"
import style0 from "./CardListSuket.vue?vue&type=style&index=0&id=2b365f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b365f16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VProgressCircular})
